import React from 'react';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const PrivacyPolicy = () => {
  useDocumentTitle('Privacy Policy — Ghost Text');
  return (
    <div className="min-h-screen bg-void">
      {/* Header */}
      <div className="bg-void/85 backdrop-blur-xl border-b border-phantom/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center space-x-3">
            <img 
              src="/GhostText.png" 
              alt="Ghost Text Logo" 
              className="h-8 w-auto rounded-lg"
            />
            <span className="text-xl font-bold text-bone">Ghost Text</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-panel rounded-2xl border border-phantom/10 p-8 lg:p-12">
          <h1 className="text-4xl font-bold text-bone mb-8">
            Privacy Policy
          </h1>
          
          <p className="text-lg text-mist mb-8">
            <strong>Effective Date:</strong> August 2025
          </p>

          <p className="text-lg text-mist mb-12">
            GhostText is committed to your privacy. This policy explains what information we collect and how we use it.
          </p>

          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                Local-First Text Extraction
              </h2>
              <p className="text-mist leading-relaxed">
                GhostText operates entirely on your device. Any extracted text or screenshots are processed locally and never leave your system. We do not collect, upload, or store your content.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                Payment Information
              </h2>
              <p className="text-mist leading-relaxed">
                If you purchase a license, we only collect the minimum required information (such as your email and payment details) through our payment provider. GhostText does not store or access your payment information.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                No Tracking or Analytics
              </h2>
              <p className="text-mist leading-relaxed">
                GhostText does not include any form of analytics or tracking. Your activity and data stay on your device—completely private.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                Your Rights
              </h2>
              <p className="text-mist leading-relaxed">
                You can contact us at any time to request removal of any data we may have collected for licensing purposes. Reach us at{' '}
                <a 
                  href="mailto:support@ghosttext.app" 
                  className="text-phantom hover:text-bone underline"
                >
                  support@ghosttext.app
                </a>
                .
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                Policy Changes
              </h2>
              <p className="text-mist leading-relaxed">
                If we make significant changes to this policy, we will notify users through the app or via email. We recommend checking this page periodically for the latest version.
              </p>
            </div>
          </div>

          {/* Back to Home */}
          <div className="mt-12 pt-8 border-t border-phantom/10">
            <a 
              href="/" 
              className="inline-flex items-center space-x-2 text-phantom hover:text-bone font-medium"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span>Back to Home</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 